module.exports = __webpack_public_path__ + "static/img/snowflake.59140be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animated/snowflake.gif
// module id = Ix6h
// module chunks = 0